<template>
    <v-container class="container" fluid>
        <v-card class="mb-5">
            <v-toolbar dark color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Invoice</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row class="justify-center py-5">
                    <v-col cols="8">
                        <v-text-field
                            v-model="searchInv"
                            append-icon="mdi-magnify"
                            dense
                            label="Search"
                            :rules="numberRule"
                            type="number"
                            @keydown="alert = false"
                            v-on:keyup.enter="searchInvoice"
                        ></v-text-field>

                        <v-alert :value="alert" type="warning">
                            {{ alertMsg }}
                        </v-alert>
                    </v-col>
                </v-row>

                <v-divider></v-divider>
                <v-form ref="form" lazy-validation>
                    <v-row class="justify-center mt-8 mb-8">
                        <v-col cols="9" md="10" sm="">
                            <v-container grid-list-xs>
                                <v-card>
                                    <v-toolbar dark color="primary" dense>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-title class="white--text"
                                            >Create</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-container grid-list-xs fluid>
                                        <v-row>
                                            <v-combobox
                                                v-model="invoiceData.Customer"
                                                :items="
                                                    toggle
                                                        ? customers
                                                        : groupCustomers
                                                "
                                                :item-text="
                                                    toggle
                                                        ? 'Name'
                                                        : 'GroupName'
                                                "
                                                :item-value="
                                                    toggle ? 'id' : 'InvGroupID'
                                                "
                                                :rules="[
                                                    v => !!v || 'Is required'
                                                ]"
                                                @change="changeFSC"
                                                required
                                                :append-outer-icon="
                                                    'mdi-swap-horizontal'
                                                "
                                                @click:append-outer="
                                                    toggle = !toggle
                                                "
                                                class="mx-6"
                                                auto-select-first
                                                :label="
                                                    toggle
                                                        ? 'Select Customer'
                                                        : 'Select Group'
                                                "
                                            ></v-combobox>
                                        </v-row>
                                        <v-row>
                                            <v-combobox
                                                v-model="InvType"
                                                :items="InvoiceType"
                                                required
                                                :rules="[
                                                    v =>
                                                        !!v ||
                                                        'Invoice is required'
                                                ]"
                                                :item-text="'InvTypeName'"
                                                :item-value="'InvTypeID'"
                                                class="mx-6"
                                                auto-select-first
                                                label="Select Invoice Type"
                                            ></v-combobox>
                                            <v-combobox
                                                v-model="InvoiceGrp"
                                                :items="invoiceGroup"
                                                required
                                                :rules="[
                                                    v =>
                                                        !!v ||
                                                        'Group is required'
                                                ]"
                                                :item-text="'InvoiceGroup'"
                                                :item-value="'InvoiceGroupID'"
                                                auto-select-first
                                                class="mx-6"
                                                label="Select Invoice Group"
                                            ></v-combobox>
                                        </v-row>
                                        <v-row>
                                            <v-text-field
                                                label="Invoice Date"
                                                type="tel"
                                                required
                                                class="mx-6"
                                                id="InvDate"
                                                :value="invoiceData.InvDate"
                                                :placeholder="
                                                    $store.state.placeholder
                                                "
                                                v-mask="$store.state.mask"
                                                :rules="$store.state.dateRules"
                                            ></v-text-field>
                                            <v-text-field
                                                v-if="toggle"
                                                label="Fuel Surcharge"
                                                v-model="invoiceData.FSC"
                                                type="number"
                                                class="mx-6"
                                                required
                                                :rules="[
                                                    v =>
                                                        !!v ||
                                                        'Fuel Surcharge is required'
                                                ]"
                                                append-icon="
                                                "
                                            ></v-text-field>
                                        </v-row>
                                        <v-row>
                                            <v-text-field
                                                label="Start Date"
                                                required
                                                type="tel"
                                                class="mx-6"
                                                id="StartDate"
                                                :value="invoiceData.StartDate"
                                                :placeholder="
                                                    $store.state.placeholder
                                                "
                                                v-mask="$store.state.mask"
                                                :rules="$store.state.dateRules"
                                            ></v-text-field>
                                            <v-text-field
                                                label="End Date"
                                                type="tel"
                                                class="mx-6"
                                                id="EndDate"
                                                :value="invoiceData.EndDate"
                                                :placeholder="
                                                    $store.state.placeholder
                                                "
                                                v-mask="$store.state.mask"
                                                :rules="$store.state.dateRules"
                                            ></v-text-field>
                                        </v-row>
                                        <v-row
                                            v-if="InvType.InvTypeID == 2"
                                            cols="6"
                                        >
                                            <v-col>
                                                <v-combobox
                                                    v-model="terminal"
                                                    :items="terminals"
                                                    required
                                                    :rules="[
                                                        v =>
                                                            !!v ||
                                                            'Terminal is required'
                                                    ]"
                                                    :item-text="'TerminalName'"
                                                    :item-value="'TerminalID'"
                                                    class="mx-3"
                                                    auto-select-first
                                                    label="Select Terminal"
                                                ></v-combobox>
                                            </v-col>
                                            <v-col>
                                                <v-btn
                                                    color="primary"
                                                    small
                                                    class="mt-5 ml-2"
                                                    @click="getTerminals"
                                                    >Check Terminals</v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                        <v-row class="justify-center">
                                            <v-col cols="12" sm="6" md="5">
                                                <v-btn
                                                    exact
                                                    dark
                                                    color="primary"
                                                    class="
                                                        mx-3
                                                        my-3
                                                        white--text
                                                    "
                                                    @click="validate('create')"
                                                >
                                                    Create and view Invoice
                                                </v-btn>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="5">
                                                <v-btn
                                                    color="success"
                                                    class="mx-10 ma-6"
                                                    dark
                                                    dense
                                                    @click="totalInvoiceByRange"
                                                >
                                                    <v-icon class="mr-2"
                                                        >mdi-printer</v-icon
                                                    >
                                                    Print By Date Range
                                                </v-btn>
                                                <v-btn
                                                    dark
                                                    @click="validate('OrderTo')"
                                                    color="primary"
                                                    class="
                                                        mx-3
                                                        my-3
                                                        white--text
                                                    "
                                                >
                                                    Orders to Invoice
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
        <v-container grid-list-xs fluid>
            <v-dialog fullscreen hide-overlay v-model="dialog">
                <v-card>
                    <v-toolbar dark color="primary">
                        Orders to Invoice
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <OrdersInvoices :parms="params" v-if="dialog" />
                </v-card>
            </v-dialog>
        </v-container>
        <multi_invoice
            v-if="dlgMultInvoice"
            :dlgMultInvoice="dlgMultInvoice"
            :invoices="invoices"
            @close="dlgMultInvoice = false"
        ></multi_invoice>
    </v-container>
</template>
<script>
import axios from 'axios';
import mmt from 'moment';
import { mask } from 'vue-the-mask';
import OrdersInvoices from './../Modals/Administration/Invoice/OrdersInvoices.vue';
import multi_invoice from './../Modals/Administration/Invoice/MultiInvoices.vue';

export default {
    name: 'InvoicesForm',

    components: {
        OrdersInvoices,
        multi_invoice
    },

    directives: {
        mask
    },

    data: function() {
        return {
            invoices: [],
            dlgMultInvoice: false,
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[3] + v[4]) <= 31 &&
                        parseInt(v[3] + v[4]) > 0) ||
                    'Date Incorrect'
            ],
            invoiceData: {
                InvDate: '',
                StartDate: '',
                EndDate: '',
                FSC: null
            },
            toggle: true,
            terminal: '',
            InvType: [],
            InvoiceGrp: [],
            InvoiceType: [],
            invoiceGroup: [],
            params: [],
            stations: [],
            customers: [],
            terminals: [],
            suppliers: [],
            orders: [],
            loading: true,
            searchInv: '',
            alert: false,
            alertMsg: '',
            marker: true,
            dialog: false,
            groupCustomers: [],
            group: [],
            numberRule: [
                v =>
                    (!isNaN(parseFloat(v)) && v >= 0) ||
                    'Only numbers are allowed'
            ]
        };
    },
    mounted() {
        this.$store.state.dateRules = this.dateRules;
        this.loadInvoiceType();
        this.loadCustomers();
        this.loadInvoiceGroup();
        this.groupCustomer();
    },
    methods: {
        totalInvoiceByRange: function() {
            // /
            var params = {
                InvDate: this.$store.state.getMsk('InvDate')
            };
            console.log(params);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('invoices/total/invoices', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.invoices = response.data;
                    this.dlgMultInvoice = true;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error.response.data);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        changeFSC: function() {
            this.invoiceData.FSC = this.invoiceData.Customer.FSC;
        },
        groupCustomer: function() {
            this.$store.state.isLoading = true;
            axios
                .get('invoice-group-customer', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.groupCustomers = response.data;
                    console.log(this.groupCustomers);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadInvoiceType: function() {
            axios
                .get('invoice-type')
                .then(response => {
                    console.log(response.data);
                    this.InvoiceType = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadInvoiceGroup: function() {
            axios
                .get('invoice-group')
                .then(response => {
                    console.log(response.data);
                    this.invoiceGroup = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getTerminals: function() {
            var str = this.$store;
            if (
                this.InvoiceGrp.InvoiceGroupID == '' ||
                this.$store.state.getMsk('StartDate') == '' ||
                this.$store.state.getMsk('EndDate') == '' ||
                this.invoiceData.Customer == null
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please fill out all the fields'
                });
            } else {
                str.state.isLoading = true;
                var params = {
                    Customer: this.invoiceData.Customer.id,
                    StartDate: this.$store.state.getMsk('StartDate'),
                    EndDate: this.$store.state.getMsk('EndDate'),
                    InvoiceGrp: this.InvoiceGrp.InvoiceGroupID
                };
                axios
                    .post('invoice/getTerminals', params)
                    .then(response => {
                        console.log(response.data);
                        this.terminals = response.data;
                        str.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.state.isLoading = false;
                    });
            }
        },
        closeModal() {
            this.$store.state.dialog = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadStations: function() {
            axios
                .get('station/active')
                .then(response => {
                    console.log(response.data.data);
                    this.stations = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getOrdersToInvoice: function() {
            this.params.length = 0;

            this.params = {
                InvTypeID: this.InvType.InvTypeID,
                InvDate: this.$store.state.getMsk('InvDate'),
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                InvoiceGrp: this.InvoiceGrp.InvoiceGroupID,
                Customer: this.invoiceData.Customer.id,
                FSC: this.invoiceData.FSC
            };
            console.log(this.params);
            this.dialog = true;
        },
        searchInvoice: async function() {
            this.$store.state.isLoading = true;

            if (this.searchInv == '') {
                this.$store.state.isLoading = false;
                this.alert = true;
                this.alertMsg = 'Invoice number needed';
            } else {
                try {
                    let response = await axios.get(
                        'invoice/' + this.searchInv,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    );
                    let type = response.data[0].InvType;
                    console.log(type);
                    if (
                        type == 'Regular Invoice' ||
                        type == 'Extra Charges' ||
                        type == 'Credit Invoice'
                    ) {
                        this.$store.state.invoiceLoadId = this.searchInv;
                        this.$router.push('/administration/view-invoiceadm');
                    } else {
                        this.$store.state.invoiceLoadId = this.searchInv;
                        this.$router.push('/administration/invoice-demurrage');
                    }
                } catch (error) {
                    if (error.response.status === 404) {
                        this.alert = true;
                        this.alertMsg = 'Invoice not found';
                        this.searchInv = '';
                    }
                }
                this.$store.state.isLoading = false;
            }
        },
        createInvoice: function() {
            var params = {
                InvTypeID: this.InvType.InvTypeID,
                InvDate: this.$store.state.getMsk('InvDate'),
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: this.invoiceData.Customer.id,
                FSC: this.invoiceData.FSC,
                InvoiceGrp: this.InvoiceGrp.InvoiceGroupID, //Region Group ID
                Terminal: this.terminal.TerminalID
            };
            var str = this.$store;

            str.state.isLoading = true;
            console.log(params, str.state.isLoading);
            axios
                .post('invoice/create', params)
                .then(response => {
                    console.log(response);
                    console.log(response.data.InvId);
                    if (
                        response.data.InvTypeID == 1 ||
                        response.data.InvTypeID == 5 ||
                        response.data.InvTypeID == 4
                    ) {
                        str.state.isLoading = false;
                        this.$store.state.invoiceLoadId = response.data.InvId;
                        this.$router.push('/administration/view-invoiceadm');
                    } else {
                        str.state.isLoading = false;
                        this.$store.state.invoiceLoadId = response.data.InvId;
                        this.$router.push('/administration/invoice-demurrage');
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        createInvoiceByGroup: function() {
            var params = {
                InvTypeID: this.InvType.InvTypeID,
                InvDate: this.$store.state.getMsk('InvDate'),
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: null,
                InvCustomerID: this.invoiceData.Customer.InvGroupID,
                Group: this.invoiceData.Customer.GroupName,
                FSC: this.invoiceData.FSC,
                InvoiceGrp: this.InvoiceGrp.InvoiceGroupID, //Region Group ID
                Terminal: this.terminal.TerminalID
            };
            var str = this.$store;

            str.state.isLoading = true;
            axios
                .post('invoice/group/create', params, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    if (response.data == 0) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'FSC Not Found'
                        });
                    } else {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Invoices Created.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        str.state.isLoading = false;
                    }
                })
                .catch(function(error) {
                    console.log(error.response.data);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'No transactions were found during this period'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Fsc not found'
                        });
                    }
                    if (error.response.status === 406) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This process is only applicable to regular invoices'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        viewOrder: function(item) {
            console.log(item.OrderID);
            this.$store.state.orderInfo.orderId = item.OrderID;
            this.orderView = true;
        },
        getMsk(id) {
            if (this.$store.state.marker == true) {
                return (
                    mmt().format('YYYY') +
                    '/' +
                    document.getElementById(id).value
                );
            } else {
                return document.getElementById(id).value;
            }
        },

        validate(i) {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (i == 'create') {
                    if (this.toggle == true) {
                        this.createInvoice();
                    } else {
                        this.createInvoiceByGroup();
                    }
                }
                if (i == 'OrderTo') {
                    this.getOrdersToInvoice();
                }
            }
        }
    }
};
</script>
